//
// AutoAlignPositions.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/GTLModel";
import "../core/Location";

var AutoAlignPositions = createModule("gtl::AutoAlignPositions", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        positions: [4],
    },
    ,
    ,
    ,
    {
        _create_v: [4],
        _create_s: [4,7],
        getValueFromString: [1,7,1],
        createNONE: [1],
    },
    ,
    ["_create"]
]);
export default AutoAlignPositions;
